import './styles/style.scss';
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import Homepage from './component/Homepage';
import Explore from './pages/Explore';
import Header from './layouts/Header';
import OverView from './pages/OverView';
import InterestedDetail from './pages/InterestedDetail';
import Login from './auth/Login';
import Privacy from './pages/Privacy'; 
import Terms from './pages/Terms';
import About from './pages/About';
import Footer from './layouts/Footer';
import SubmitProblem from './pages/SubmitProblem';
import PrivateRoutes from './config/PrivateRoutes';
import Register from './auth/Register';
import Verify from './pages/Verify';
import Features from './pages/Features';
import WhatsNew from './pages/WhatsNew';
import Movies from './pages/Movies';
import { Toaster } from 'react-hot-toast';
import AdminInterestedDetail from './Admin/AdminInterestedDetail';


function App() {

     function LoginLayout() {
          return (
               <div role="main">
                    <Header />
                    <Outlet />
                    <Footer />
               </div>
          );
     }

     function HomeLayout() {
          return (
               <div role="main">
                    <Header />
                    <Outlet />
                    <Footer />
               </div>
          );
     }

     return (
          <Router>
               <Routes>
                    <Route element={<LoginLayout />}>
                         <Route path='/login' element={<Login />} />
                         <Route path='/register' element={<Register />} />
                         
                    </Route>

                    <Route element={<HomeLayout />}>
                         <Route path='*' element={<Homepage />} />
                         <Route path='/privacy' element={<Privacy />} />
                         <Route path='/terms' element={<Terms />} />
                         <Route path='/about' element={<About />} />
                         <Route path='/explore' element={<Explore />} />
                         <Route path='/interested/:id' element={<InterestedDetail />} />
                         <Route path='/admin/interested/:id' element={<AdminInterestedDetail />} />
                         <Route path='/submit' element={<SubmitProblem />} />
                         <Route path='/features' element={<Features />} />
                         <Route path='/whats-new' element={<WhatsNew />} />
                         <Route path='/movies' element={<Movies />} />

                         <Route element={<PrivateRoutes />}>
                              <Route path='/verify' element={<Verify />} />
                              <Route path='/overview' element={<OverView />} />
                         </Route>
                    </Route>
               </Routes>

                <Toaster
                         position="bottom-left"
                         reverseOrder={false}
                         gutter={12}
                         toastOptions={{
                              duration: 3000,
                         }}
                    />
          </Router>
     );
}

export default App;
